

import { createHelpers } from 'vuex-map-fields';

const { getLicenciaField, updateLicenciaField } = createHelpers({
  getterType: 'getLicenciaField',
  mutationType: 'updateLicenciaField',
});

export default {
  namespaced: true,
  state: {
    SearchTerm: '',
    Personal: null,
    Personal_Id: null,
    FechaDesde: null,
    FechaHasta: null,
    CantidadDias: 0,
    Fecha: null,
    SolicitudSeleccionada:null,
    SolicitudSeleccionada_Id: 0,
    CIE10:null,
    CIE10_Id: 0,
    TipoLicencia_Id: 0,
    DetalleDiasLicencia_Id: 0,
    TipoLicencia: null,
    DetalleDiasLicencia: null,
    Observaciones: '',
    mostrarcie10: false
  },
  mutations: {
    updateLicenciaField,
  },
  getters: {
    getLicenciaField,
  }
};



// WEBPACK FOOTER //
// ./src/store/formlicencia.js